import { render, staticRenderFns } from "./filterItem.vue?vue&type=template&id=967a1daa"
import script from "./filterItem.vue?vue&type=script&lang=js"
export * from "./filterItem.vue?vue&type=script&lang=js"
import style0 from "./filterItem.vue?vue&type=style&index=0&id=967a1daa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports